// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2LMqU","content":"LayoutSettings_content__3uVXE"};